/**
 * CMOE shadow parity — structured validation results (Phase 2.5).
 */

/** @typedef {'Setup' | 'GoLive' | 'Pause' | 'Resume' | 'Complete' | 'LeaseTransfer' | 'Manual'} ShadowOperation */

/** @typedef {'roomMatches' | 'matchStatus' | 'manager' | 'participantBindings' | 'allocation' | 'activityAttachment' | 'matchCompletion' | 'permissionGrants'} ParityDimension */

/**
 * @typedef {Object} ParityDimensionResult
 * @property {boolean} ok
 * @property {boolean} [skipped]
 * @property {string} [reason]
 * @property {unknown} [expected]
 * @property {unknown} [actual]
 * @property {Record<string, unknown>} [details]
 */

/**
 * @typedef {Object} RoomSessionParityReport
 * @property {boolean} ok
 * @property {string} roomCode
 * @property {string} competitionId
 * @property {ShadowOperation} operation
 * @property {string | null} [focusMatchId]
 * @property {number} checkedAtMs
 * @property {number} mismatchCount
 * @property {Partial<Record<ParityDimension, ParityDimensionResult>>} dimensions
 */

export const PARITY_DIMENSIONS = /** @type {ParityDimension[]} */ ([
  "roomMatches",
  "matchStatus",
  "manager",
  "participantBindings",
  "allocation",
  "activityAttachment",
  "matchCompletion",
  "permissionGrants",
]);

export const SHADOW_OPERATIONS = /** @type {ShadowOperation[]} */ ([
  "Setup",
  "GoLive",
  "Pause",
  "Resume",
  "Complete",
  "LeaseTransfer",
  "Manual",
]);
